import { PropsWithChildren } from "react";
import styled from "@emotion/styled";

const StepContainer = styled.div`
  display: flex;
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacings.xl};
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  margin-top: ${({ theme }) => theme.spacings.xs};
  background-color: ${({ theme }) => theme.colors.action.client.default};
  border-radius: 50%;
  flex-shrink: 0;
`;

const ConnectingLine = styled.div`
  width: 1px;
  background-color: ${({ theme }) => theme.colors.action.client.default};
  flex-grow: 1;
  min-height: ${({ theme }) => theme.spacings.xl};
`;

const RightColumn = styled.div`
  flex-grow: 1;
  padding-bottom: ${({ theme }) => theme.spacings.lg};
`;

const StepTitle = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary.default};
  margin-bottom: ${({ theme }) => theme.spacings.sm};
  margin-top: 0;
`;

// The first child gets no margin.
// Every child after the first gets a top margin.
const ContentWrapper = styled.div`
  & > * + * {
    margin-top: ${({ theme }) => theme.spacings.sm};
  }
`;

export interface TimelineStepProps extends PropsWithChildren {
  title: string;
  isLast?: boolean;
}

export const TimelineStep = ({
  title,
  children,
  isLast = false,
}: TimelineStepProps) => {
  return (
    <StepContainer>
      <LeftColumn>
        <Dot />
        {!isLast && <ConnectingLine />}
      </LeftColumn>

      <RightColumn>
        <StepTitle>{title}</StepTitle>
        <ContentWrapper>{children}</ContentWrapper>
      </RightColumn>
    </StepContainer>
  );
};
